<template>
    <card :disabled="disabled" :flat="flat" :outlined="outlined" :to="to" :height="height" @click="handleClick" clickable no-spacing class="p-16 items-center justify-center border-box w-full" :class="{'cursor-not-allowed': disabled}">
        <loading-icon v-if="isLoading"/>
        <template v-else>
            <cdn-image v-if="image" class="mb-10 h-24" :src="image" :height="24"/>
            <Icon v-else-if="icon" class="text-gray-300 mb-10" :icon="icon"/>
            <span v-if="text" class="text-text-color leading-tight text-center text-sm">{{ text }}</span>
            <span v-if="help" class="text-xs text-center leading-normal mt-5 text-gray-400 whitespace-pre-wrap max-w-600">{{ help }}</span>
            <slot/>
        </template>
    </card>
</template>

<script>
import Linkable from "../../mixins/Linkable";
    import CardMixin from "../Card/CardMixin";

    export default {
        name: 'AddBtn',

        mixins: [Linkable, CardMixin],

		emits: ['click'],

        props: {

            // The 'add' icon to show on the button
            icon: {
                type: String,
                default: null
            },

			// The 'add' image to show on the button
			image: {
				type: String,
				default: null
			},

            text: {
                type: String,
                default: null
            },

            disabled: {
                type: Boolean,
                default: false
            },

            help: {
                type: String,
                default: null
            }
        },

        methods: {

            /**
             * Handles a click on the element.
             */
            handleClick() {
                this.$emit('click');
            }
        }
    }
</script>